<template>
  <div class="home_wrap">
    <header class="home-header">
      <img
        class="brand-logo"
        src="../images/index/friendlogo.png"
        alt="Hotwire"
      >
      <button
        class="language-chip"
        type="button"
        @click="$router.push('/language')"
      >
        <img
          class="language-icon"
          :src="languageIcon"
          alt=""
        >
        <span>{{ $t('index.languageLabel') }}</span>
      </button>
    </header>

    <section class="hero-section">
      <img
        class="hero-image"
        :src="heroImage"
        alt=""
        @error="onHeroImageError"
      >
    </section>

    <section class="hotel-search">
      <h1>{{ $t('index.hotelSearch') }}</h1>
      <label class="field-block">
        <span>{{ $t('index.destination') }}</span>
        <div class="input-shell">
          <van-icon name="location-o" />
          <input
            v-model.trim="searchForm.destination"
            type="text"
            :placeholder="$t('index.destinationPlaceholder')"
          >
        </div>
      </label>
      <div class="date-grid">
        <label class="field-block">
          <span>{{ $t('index.startDate') }}</span>
          <div class="date-shell">
            <van-icon name="notes-o" />
            <input
              v-model="searchForm.startDate"
              readonly
              type="text"
              @click="openDatePicker"
            >
          </div>
        </label>
        <label class="field-block">
          <span>{{ $t('index.endDate') }}</span>
          <div class="date-shell">
            <van-icon name="notes-o" />
            <input
              v-model="searchForm.endDate"
              readonly
              type="text"
              @click="openDatePicker"
            >
          </div>
        </label>
      </div>
      <button
        class="search-button"
        type="button"
        @click="searchHotel"
      >
        {{ $t('index.searchHotel') }}
      </button>
    </section>

    <section class="recommend-section">
      <h2>{{ $t('index.featuredRecommend') }}</h2>
      <div
        v-if="homeRecommends.length"
        class="recommend-grid"
      >
        <article
          v-for="item in homeRecommends"
          :key="item.id"
          class="recommend-card"
          role="button"
          @click="goHotelDetail(item)"
        >
          <div class="hotel-image-wrap">
            <img
              :src="hotelImage(item)"
              alt=""
              @error="onHotelImageError"
            >
          </div>
          <div class="hotel-title">
            {{ item.title || '--' }}
          </div>
          <div class="hotel-meta">
            <span class="price">${{ formatPrice(item.price) }}</span>
            <span class="sold">{{ $t('index.sold') }}{{ formatSold(item.sold) }}</span>
          </div>
        </article>
      </div>
      <div
        v-else
        class="empty-recommend"
      >
        {{ $t('index.emptyRecommend') }}
      </div>
    </section>

    <FloatingCustomerService
      v-if="!datePicker.show"
      :service-url="app.kefu"
      :bottom="95"
    />

    <div
      v-if="datePicker.show"
      class="date-picker-layer"
    >
      <div class="date-picker-bar">
        <button
          class="date-reset"
          type="button"
          @click="resetPendingDates"
        >
          {{ $t('index.dateReset') }}
        </button>
        <button
          class="date-close"
          type="button"
          @click="closeDatePicker"
        >
          <van-icon name="cross" />
        </button>
      </div>
      <div
        ref="calendarScroller"
        class="date-calendar"
      >
        <section
          v-for="month in calendarMonths"
          :key="month.key"
          class="calendar-month"
        >
          <h3>{{ month.title }}</h3>
          <div class="weekday-row">
            <span
              v-for="(weekday, index) in weekdayLabels"
              :key="index"
            >
              {{ weekday }}
            </span>
          </div>
          <div class="calendar-grid">
            <button
              v-for="day in month.days"
              :key="day.key"
              class="calendar-day"
              :class="getDateClass(day)"
              :disabled="day.disabled || !day.date"
              type="button"
              @click="selectDate(day.date)"
            >
              <span v-if="day.date">{{ day.label }}</span>
            </button>
          </div>
        </section>
      </div>
      <div class="date-picker-footer">
        <button
          class="date-confirm"
          type="button"
          @click="confirmDateRange"
        >
          {{ $t('index.selectDates') }}
        </button>
      </div>
    </div>

    <van-popup
      v-model="show"
      round
      closeable
      :style="{
        'line-height': '30px',
        'width': '70%',
        'padding': '15px',
        'font-weight': 'bold'
      }"
      @close="handleNoticePopupClose"
    >
      {{ msg }}
    </van-popup>
    <van-dialog
      v-model="show_tc"
      :confirm-button-text="$t('utils.confirm')"
    >
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import FloatingCustomerService from '../../components/FloatingCustomerService.vue';
import {
  Icon,
  Popup,
  Dialog,
} from 'vant';

Vue.use(Icon).use(Popup).use(Dialog);

export default {
  name: 'Index',
  components: {
    FloatingCustomerService,
  },
  data() {
    return {
      lang: this.$i18n.locale || 'zh_cn',
      data: {},
      app: {},
      acc: null,
      banner: [],
      msg_show: true,
      msg: null,
      show: false,
      popupMessageId: null,
      show_tc: false,
      tc_content: '',
      heroFallback: require('../images/shop2/pro.png'),
      hotelFallback: require('../images/shop2/pro.png'),
      languageIcons: {
        en_us: require('../images/language/en_us.png'),
        zh_cn: require('../images/language/zh_cn.png'),
        zh_hk: require('../images/language/zh_hk.png'),
        bg_bg: require('../images/language/bg_bg.png'),
        id_ind: require('../images/language/id_ind.png'),
        th_th: require('../images/language/th_th.png'),
        vi_vn: require('../images/language/vi_vn.png'),
        ja_jp: require('../images/language/ja_jp.png'),
        ko_kr: require('../images/language/ko_kr.png'),
        ms_my: require('../images/language/ms_my.png'),
        pt_br: require('../images/language/pt_br.png'),
        ro_ro: require('../images/language/ro_ro.png'),
        tr_tr: require('../images/language/tr_tr.png'),
        // uz_uz: require('../images/language/uz_uz.png'),
        pl_pl: require('../images/language/pl_pl.png'),
      },
      searchForm: {
        destination: '',
        startDate: '',
        endDate: '',
      },
      dateRange: {
        start: null,
        end: null,
      },
      datePicker: {
        show: false,
        pendingStart: null,
        pendingEnd: null,
        monthCount: 13,
      },
    };
  },
  computed: {
    languageIcon() {
      return this.languageIcons[this.lang] || this.languageIcons.en_us;
    },
    heroImage() {
      if (Array.isArray(this.banner) && this.banner.length) {
        return this.buildImageUrl(this.banner[0][this.lang], this.heroFallback);
      }
      return this.heroFallback;
    },
    homeRecommends() {
      return Array.isArray(this.data.home_recommend_pros) ? this.data.home_recommend_pros : [];
    },
    weekdayLabels() {
      var formatter = new Intl.DateTimeFormat(this.dateLocale(), {
        weekday: 'narrow',
      });
      var start = new Date(2026, 0, 4);
      var labels = [];
      for (var i = 0; i < 7; i++) {
        var date = new Date(start.getTime());
        date.setDate(start.getDate() + i);
        labels.push(formatter.format(date));
      }
      return labels;
    },
    calendarMonths() {
      var months = [];
      var today = this.startOfDay(new Date());
      var base = new Date(today.getFullYear(), today.getMonth(), 1);
      for (var i = 0; i < this.datePicker.monthCount; i++) {
        var monthDate = new Date(base.getFullYear(), base.getMonth() + i, 1);
        months.push(this.createCalendarMonth(monthDate, today));
      }
      return months;
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('index');
    }
  },
  mounted() {
    this.setDefaultDates();
    this.start();
    if (this.$router.history.current.query.agent) {
      localStorage.setItem('agent', this.$router.history.current.query.agent);
    }
    if (this.$router.history.current.query.isapp) {
      localStorage.setItem('isapp', 'true');
    }
  },
  methods: {
    start() {
      Fetch('/index/int').then((r) => {
        this.data = r.data || {};
        this.banner = this.data.banner || [];
        if (this.data.popup && this.data.popup.show == 1) {
          this.tc_content = this.data.popup.content;
          if (localStorage.getItem('tc') !== this.tc_content) {
            localStorage.setItem('tc', this.tc_content);
            this.show_tc = true;
          }
        }
      });
      // Fetch('/user/basicinfo').then((r) => {
      //   this.acc = r.data;
      // });
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      setTimeout(() => {
        this.sync();
      }, 2000);
    },
    sync() {
      Fetch('/index/sync', {}, null, false).then((r) => {
        var list = r.data;
        if (list && list.length > 0) {
          this.msg = list[0]["content_"+this.lang];
          this.popupMessageId = Number(list[0].id) || null;
          // console.log(this.lang);
          this.show = true;
        }
      });
    },
    handleNoticePopupClose() {
      var messageId = this.popupMessageId;
      this.popupMessageId = null;
      if (!messageId) {
        return;
      }
      Fetch('/user/notice_view', {
        id: messageId,
      }).catch(() => {});
    },
    setDefaultDates() {
      var start = this.startOfDay(new Date());
      var end = new Date(start.getTime());
      end.setDate(start.getDate() + 1);
      this.setDateRange(start, end);
    },
    setDateRange(start, end) {
      this.dateRange.start = this.cloneDate(start);
      this.dateRange.end = this.cloneDate(end);
      this.searchForm.startDate = this.formatDate(start);
      this.searchForm.endDate = this.formatDate(end);
    },
    formatDate(date) {
      return this.padDate(date.getMonth() + 1) + '/' + this.padDate(date.getDate()) + '/' + date.getFullYear();
    },
    padDate(value) {
      return value < 10 ? '0' + value : String(value);
    },
    cloneDate(date) {
      return date ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : null;
    },
    startOfDay(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    dateLocale() {
      var map = {
        zh_cn: 'zh-CN',
        zh_hk: 'zh-HK',
        en_us: 'en-US',
        bg_bg: 'bg_bg',
        id_ind: 'id-ID',
        th_th: 'th-TH',
        vi_vn: 'vi-VN',
        ja_jp: 'ja-JP',
        ko_kr: 'ko-KR',
        ms_my: 'ms-MY',
        tr_tr: 'tr_tr',
        uz_uz: 'uz_uz',
        pl_pl: 'pl_pl',
        ro_ro: 'ro_ro',
        pt_br: 'pt-BR',
      };
      return map[this.lang] || 'en-US';
    },
    monthTitle(date) {
      return new Intl.DateTimeFormat(this.dateLocale(), {
        month: 'long',
        year: 'numeric',
      }).format(date);
    },
    createCalendarMonth(monthDate, minDate) {
      var days = [];
      var firstDay = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
      var daysInMonth = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
      for (var blank = 0; blank < firstDay.getDay(); blank++) {
        days.push({
          key: 'blank-' + monthDate.getFullYear() + '-' + monthDate.getMonth() + '-' + blank,
          date: null,
          label: '',
          disabled: true,
        });
      }
      for (var day = 1; day <= daysInMonth; day++) {
        var date = new Date(monthDate.getFullYear(), monthDate.getMonth(), day);
        days.push({
          key: this.dateKey(date),
          date: date,
          label: day,
          disabled: this.compareDate(date, minDate) < 0,
        });
      }
      return {
        key: monthDate.getFullYear() + '-' + monthDate.getMonth(),
        title: this.monthTitle(monthDate),
        days: days,
      };
    },
    dateKey(date) {
      return date.getFullYear() + '-' + this.padDate(date.getMonth() + 1) + '-' + this.padDate(date.getDate());
    },
    compareDate(left, right) {
      var leftTime = this.startOfDay(left).getTime();
      var rightTime = this.startOfDay(right).getTime();
      if (leftTime === rightTime) {
        return 0;
      }
      return leftTime > rightTime ? 1 : -1;
    },
    sameDate(left, right) {
      return !!left && !!right && this.compareDate(left, right) === 0;
    },
    inPendingRange(date) {
      if (!date || !this.datePicker.pendingStart || !this.datePicker.pendingEnd) {
        return false;
      }
      return this.compareDate(date, this.datePicker.pendingStart) > 0 &&
        this.compareDate(date, this.datePicker.pendingEnd) < 0;
    },
    getDateClass(day) {
      if (!day.date) {
        return {
          'is-empty': true,
        };
      }
      return {
        'is-disabled': day.disabled,
        'is-start': this.sameDate(day.date, this.datePicker.pendingStart),
        'is-end': this.sameDate(day.date, this.datePicker.pendingEnd),
        'is-range': this.inPendingRange(day.date),
      };
    },
    openDatePicker() {
      this.datePicker.pendingStart = this.cloneDate(this.dateRange.start);
      this.datePicker.pendingEnd = this.cloneDate(this.dateRange.end);
      this.datePicker.show = true;
      this.$nextTick(() => {
        if (this.$refs.calendarScroller) {
          this.$refs.calendarScroller.scrollTop = 0;
        }
      });
    },
    closeDatePicker() {
      this.datePicker.show = false;
    },
    resetPendingDates() {
      var start = this.startOfDay(new Date());
      var end = new Date(start.getTime());
      end.setDate(start.getDate() + 1);
      this.datePicker.pendingStart = start;
      this.datePicker.pendingEnd = end;
      this.$nextTick(() => {
        if (this.$refs.calendarScroller) {
          this.$refs.calendarScroller.scrollTop = 0;
        }
      });
    },
    selectDate(date) {
      if (!date) {
        return;
      }
      var selected = this.cloneDate(date);
      if (!this.datePicker.pendingStart || this.datePicker.pendingEnd) {
        this.datePicker.pendingStart = selected;
        this.datePicker.pendingEnd = null;
        return;
      }
      if (this.compareDate(selected, this.datePicker.pendingStart) < 0) {
        this.datePicker.pendingEnd = this.cloneDate(this.datePicker.pendingStart);
        this.datePicker.pendingStart = selected;
        return;
      }
      this.datePicker.pendingEnd = selected;
    },
    confirmDateRange() {
      if (!this.datePicker.pendingStart) {
        this.resetPendingDates();
      }
      if (!this.datePicker.pendingEnd) {
        var end = new Date(this.datePicker.pendingStart.getTime());
        end.setDate(this.datePicker.pendingStart.getDate() + 1);
        this.datePicker.pendingEnd = end;
      }
      if (this.compareDate(this.datePicker.pendingStart, this.datePicker.pendingEnd) > 0) {
        var start = this.datePicker.pendingEnd;
        this.datePicker.pendingEnd = this.datePicker.pendingStart;
        this.datePicker.pendingStart = start;
      }
      this.setDateRange(this.datePicker.pendingStart, this.datePicker.pendingEnd);
      this.closeDatePicker();
    },
    searchHotel() {
      // var link = document.createElement('a');
      // link.href = 'https://www.hotwire.com/';
      // link.rel = 'noreferrer noopener';
      // link.target = '_self';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    buildImageUrl(path, fallback) {
      if (!path) {
        return fallback;
      }
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      if (this.app && this.app.domain) {
        return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
      }
      return path;
    },
    hotelImage(item) {
      return this.buildImageUrl(item && item.img, this.hotelFallback);
    },
    goHotelDetail(item) {
      var id = Number(item && item.id ? item.id : 0);
      if (!id) {
        return;
      }
      this.$router.push({
        path: '/hotelit',
        query: {
          id: id,
        },
      });
    },
    onHeroImageError(event) {
      if (event && event.target && event.target.src !== this.heroFallback) {
        event.target.src = this.heroFallback;
      }
    },
    onHotelImageError(event) {
      if (event && event.target && event.target.src !== this.hotelFallback) {
        event.target.src = this.hotelFallback;
      }
    },
    formatMoney(value) {
      var number = Number(value);
      if (!isFinite(number)) {
        number = 0;
      }
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatPrice(value) {
      return this.formatMoney(value);
    },
    formatSold(value) {
      var number = Number(value);
      if (!isFinite(number) || number < 0) {
        number = 0;
      }
      if (number >= 1000) {
        var shortNumber = number / 1000;
        var fixed = shortNumber >= 10 ? shortNumber.toFixed(0) : shortNumber.toFixed(1);
        return fixed.replace(/\.0$/, '') + 'k+';
      }
      return String(Math.floor(number));
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  min-height: 100vh;
  padding-bottom: 82px;
  background: #f1f2f7;
  color: #101a33;
}

.home-header {
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  box-sizing: border-box;
}

.brand-logo {
  display: block;
  width: auto;
  height: 50px;
}

.language-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #111827;
  font-size: 12px;
  line-height: 18px;
}

.language-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.hero-section {
  background: #fff;
}

.hero-image {
  display: block;
  width: 100%;
  height: 66vw;
  min-height: 245px;
  max-height: 382px;
  object-fit: cover;
}

.hotel-search {
  padding: 22px 28px 26px;
  background: #f1f2f7;
  box-sizing: border-box;
}

.hotel-search h1 {
  margin: 0 0 18px;
  text-align: center;
  color: #f20912;
  font-size: 20px;
  line-height: 22px;
  font-weight: bold;
}

.field-block {
  display: block;
  margin: 0;
  color: #112344;
  font-size: 14px;
  line-height: 20px;
}

.field-block > span {
  display: block;
  margin-bottom: 8px;
}

.input-shell,
.date-shell {
  height: 44px;
  display: flex;
  align-items: center;
  border: 1px solid #b9c2d2;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box;
  color: #162542;
}

.input-shell {
  padding: 0 16px;
}

.date-shell {
  padding: 0 14px;
}

.input-shell .van-icon,
.date-shell .van-icon {
  flex: 0 0 auto;
  margin-right: 8px;
  color: #26364f;
  font-size: 18px;
}

.input-shell input,
.date-shell input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  padding: 0;
  background: transparent;
  color: #162542;
  font-size: 14px;
  line-height: 20px;
}

.date-shell input[readonly] {
  cursor: pointer;
}

.input-shell input::placeholder {
  color: #a9b0bd;
}

.date-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px;
  margin-top: 20px;
}

.search-button {
  width: 194px;
  height: 44px;
  display: block;
  margin: 25px auto 0;
  border: 0;
  border-radius: 22px;
  background: #f5060b;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
}

.recommend-section {
  padding: 0 14px 18px;
  background: #f1f2f7;
}

.recommend-section h2 {
  margin: 0 0 14px;
  color: #152238;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
}

.recommend-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 14px 18px;
}

.recommend-card {
  min-width: 0;
}

.hotel-image-wrap {
  width: 100%;
  height: 23vw;
  min-height: 86px;
  max-height: 134px;
  overflow: hidden;
  border-radius: 6px;
  background: #fff;
}

.hotel-image-wrap img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hotel-title {
  margin-top: 8px;
  color: #001733;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hotel-meta {
  min-width: 0;
  display: flex;
  align-items: center;
  margin-top: 3px;
  line-height: 16px;
}

.price {
  flex: 0 0 auto;
  color: #f5060b;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.sold {
  min-width: 0;
  margin-left: 5px;
  color: #8a8d96;
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-recommend {
  padding: 24px 12px;
  border-radius: 7px;
  background: #fff;
  text-align: center;
  font-size: 12px;
  color: #8a8d96;
}

.date-picker-layer {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: #fff;
  color: #2c3443;
}

.date-picker-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2001;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0 6px 14px rgba(20, 24, 34, .06);
  box-sizing: border-box;
}

.date-reset,
.date-close {
  border: 0;
  padding: 0;
  background: transparent;
  font-size: 14px;
  line-height: 20px;
}

.date-reset {
  color: #008b91;
  font-weight: 700;
}

.date-close {
  color: #252c3b;
}

.date-close .van-icon {
  font-size: 22px;
  line-height: 22px;
}

.date-calendar {
  height: 100vh;
  padding: 76px 18px 116px;
  overflow-y: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.calendar-month {
  margin-bottom: 44px;
}

.calendar-month h3 {
  margin: 8px 0 18px;
  color: #303746;
  text-align: center;
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
}

.weekday-row,
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.weekday-row {
  height: 28px;
  align-items: center;
  border-bottom: 1px solid #d9dbe1;
  color: #2e3542;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-align: center;
}

.calendar-grid {
  row-gap: 8px;
  padding-top: 18px;
}

.calendar-day {
  position: relative;
  height: 48px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #292d36;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
}

.calendar-day span {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.calendar-day.is-disabled {
  color: #d0d0d0;
}

.calendar-day.is-range span {
  background: #fde0e1;
  color: #e73539;
}

.calendar-day.is-start span,
.calendar-day.is-end span {
  background: #e4383c;
  color: #fff;
}

.calendar-day.is-empty {
  pointer-events: none;
}

.date-picker-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
  padding: 14px 18px calc(22px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, rgba(255, 255, 255, .78), #fff 28%);
  box-sizing: border-box;
}

.date-confirm {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 24px;
  background: #e4383c;
  color: #fff;
  box-shadow: 0 4px 10px rgba(208, 36, 40, .24);
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
}

.popup {
  padding: 12px;
  color: #1f2937;
  font-size: 12px;
  line-height: 20px;
}

@media (max-width: 360px) {
  .home-header {
    padding: 0 18px;
  }

  .hotel-search {
    padding-right: 18px;
    padding-left: 18px;
  }

  .search-button {
    width: 180px;
  }
}
</style>
